/**
 * A saved card's answered state, rebuilt from the messages that follow it. Pure.
 */

/** The answer a later message gave to one of these cards, or null when none did. */
export function resolutionOf(cards, laterMessages) {
  const ids = new Set(cards.map((c) => c && c.id));
  const answer = laterMessages
    .map((m) => m?.context_metadata?.interaction_response)
    .find((r) => r && ids.has(r.interaction_id));
  return answer ? { selections: answer.values?.selections || [] } : null;
}
